module.exports = __webpack_public_path__ + "img/upwork-review-large-2.5208827e.jpg";